import { TranslateService } from '@ngx-translate/core';

export function fillBraces(text: string, params?: any): string {
  if (typeof text !== 'string')
    return '';
  const values = params || {};
  return text.replace(/(\{)?\{(\w+)\}(\})?/g, (match: string, open: string, key: string, close: string) => {
    if (open || close || !Object.prototype.hasOwnProperty.call(values, key))
      return match;
    const value = values[key];
    return value === undefined || value === null ? match : String(value);
  });
}

export function homeTranslate(translate: TranslateService, key: string, params?: any): string {
  return fillBraces(translate.instant(key, params), params);
}



// WEBPACK FOOTER //
// ./src/providers/homescreen/home-revamp-translate.ts